import { Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { NotFoundPage } from '../../routes/ErrorPages';

/**
 * Presentational half of the recorder gate, exported separately so the route
 * behavior can be tested without mocking the authentication provider.
 */
export function V2RecorderGate({ enabled }: { enabled: boolean }) {
  return enabled ? <Outlet /> : <NotFoundPage />;
}

/**
 * UX gate for recorder routes. The API guard remains authoritative.
 *
 * Open while the recorder answers this user, not only while they may start
 * one: a walkthrough started before its workspace lost access may still be
 * reviewed and committed (TOADO-493). The page itself decides whether to
 * offer a new recording, per workspace.
 */
export function RequireV2Recorder() {
  const { features } = useAuth();
  return <V2RecorderGate enabled={features.v2RecorderRoutes} />;
}
